export default {
  articles: {
    breadcrumbHome: "Inicio",
    breadcrumbGuides: "Guías",
    author: "Equipo editorial de USFansLink",
    readingTime: "7 min de lectura",
    lastUpdated: "Última actualización: agosto de 2026",
    notFound: "Guía no encontrada",
    tocTitle: "Índice",
    s1Title: "Por qué este tema importa",
    s1Body:
      "Cada parte del proceso de investigación de USFans, desde las listas de productos hasta los detalles de envío, influye en las decisiones que tomas antes de comprar. Cuando entiendes cómo encaja esta pieza en el panorama general, puedes comparar opciones con más confianza y evitar sorpresas más tarde.",
    s2Title: "Cómo empezar",
    s2Body:
      "Empieza por las categorías o columnas que más te importan y luego reduce los resultados paso a paso. Un enfoque simple y repetible — revisar, comparar y confirmar los detalles — mantiene tu investigación organizada y facilita detectar la información que realmente necesitas.",
    s3Title: "Qué tener en cuenta",
    s3Body:
      "Los detalles pueden cambiar y no todas las opciones funcionan igual. Vuelve a revisar las notas más recientes, confirma la información de envío y pago, y ten cuidado con cualquier cosa que parezca inusual. Dedicar unos minutos extra al principio suele ahorrar tiempo y problemas después.",
    faqTitle: "Preguntas frecuentes",
    faq: [
      {
        q: "¿Esta guía se mantiene actualizada?",
        a: "Revisamos y actualizamos nuestras guías con regularidad, pero detalles como los costos de envío y las ofertas pueden cambiar rápido, así que confirma siempre la información más reciente en la tienda antes de comprar.",
      },
      {
        q: "¿Necesito una cuenta para usar esta información?",
        a: "No, la mayoría de estas guías y recursos son gratuitos. Es posible que necesites iniciar sesión para completar una compra en la tienda principal.",
      },
      {
        q: "¿Dónde puedo encontrar más recursos de USFans?",
        a: "Explora las guías relacionadas enlazadas en esta página o vuelve a la página de inicio de USFansLink para ver el conjunto completo de recursos.",
      },
    ],
    relatedTitle: "Recursos relacionados de USFans",
    relatedIntro: "Sigue explorando con estas guías y recursos relacionados.",
    relatedHome: "Volver a la página de inicio de USFansLink",
    relatedGuide: "Guía completa de la hoja de cálculo de USFans",
    conclusionTitle: "Continúa tu investigación de USFans",
    conclusionBody:
      "Usa lo que has aprendido aquí para continuar tu investigación con más confianza y explora las categorías y guías organizadas cuando estés listo.",
    cta: "Explorar la hoja de cálculo de USFans",
    backHome: "Volver al inicio",
    disclaimer:
      "Esta guía es un recurso informativo independiente y no está afiliada ni respaldada por USFans, salvo que se indique explícitamente.",
    list: {
      "usfans-spreadsheet-list": {
        title: "Lista de productos de la hoja de cálculo de USFans: cómo navegar y comparar",
        excerpt:
          "La lista de productos de la hoja de cálculo de USFans reúne artículos, categorías y vendedores en una sola vista. Aprende a navegarla, comparar opciones y acotar productos antes de entrar a la tienda.",
        tag: "Guía de productos",
      },
      "usfans-seller-spreadsheet": {
        title: "Hoja de cálculo de vendedores de USFans: investiga vendedores de forma inteligente",
        excerpt:
          "La información del vendedor puede decidir una compra. Esta guía explica cómo la hoja de vendedores te ayuda a revisar historiales, comparar opciones y detectar a los vendedores que valen la pena.",
        tag: "Guía de vendedores",
      },
      "how-to-use-usfans-spreadsheet": {
        title: "Cómo usar la hoja de cálculo de USFans: guía paso a paso",
        excerpt:
          "¿Nuevo en la hoja de cálculo de USFans? Esta guía paso a paso recorre categorías, filtros y columnas para pasar de una pantalla vacía a una lista corta de productos sin adivinar.",
        tag: "Guía para principiantes",
      },
      "usfans-product-research": {
        title: "Guía de investigación de productos de USFans: encuentra lo que necesitas más rápido",
        excerpt:
          "Una buena investigación de productos ahorra tiempo y dinero. Aprende un flujo simple para comparar artículos, revisar detalles y armar una lista corta antes de comprar.",
        tag: "Guía de investigación",
      },
      "usfans-seller-research": {
        title: "Guía de investigación de vendedores de USFans: detecta vendedores fiables",
        excerpt:
          "Una revisión cuidadosa del vendedor reduce el riesgo antes de comprar. Esta guía cubre qué buscar en el historial, las reseñas y los detalles de envío, y cómo marcar lo sospechoso.",
        tag: "Guía de investigación",
      },
      "usfans-shipping-guide": {
        title: "Guía de envío de USFans: opciones, costos y entrega",
        excerpt:
          "Las opciones y costos de envío varían mucho según el vendedor y el destino. Esta guía explica los métodos comunes, qué afecta el tiempo de entrega y cómo confirmar el costo final antes de pedir.",
        tag: "Guía de envío",
      },
      "usfans-coupon-guide": {
        title: "Guía de cupones de USFans: encuentra y aplica ofertas actuales",
        excerpt:
          "Los cupones van y vienen, y no todos los códigos funcionan en cada pedido. Aprende dónde aparecen las ofertas, cómo aplicarlas y qué revisar antes de pagar.",
        tag: "Guía de ahorro",
      },
      "usfans-discount-code-guide": {
        title: "Guía de códigos de descuento de USFans: dónde aparecen las ofertas",
        excerpt:
          "Los códigos de descuento pueden bajar tu total, pero solo cuando coinciden con tu pedido. Esta guía explica dónde aparecen, cómo probarlos y las razones comunes por las que un código no aplica.",
        tag: "Guía de ahorro",
      },
      "usfans-warehouse-guide": {
        title: "Guía del almacén de USFans: almacenamiento y entrega explicados",
        excerpt:
          "Los procesos de almacén afectan la rapidez con la que se envía tu pedido. Aprende cómo funciona el almacenamiento, qué significa para el tiempo de entrega y qué revisar en las notas del almacén.",
        tag: "Guía de logística",
      },
      "usfans-qc-guide": {
        title: "Guía de control de calidad de USFans: revisa la calidad antes de comprar",
        excerpt:
          "Las fotos y listas de control de calidad ayudan a detectar problemas antes del envío. Esta guía explica qué buscar, cómo leer las fotos de QC y cómo señalar dudas a tiempo.",
        tag: "Guía de calidad",
      },
    },
  },
};